import MileageDictionaryListRequest from "../../../../api/raily/mileage/dictionary/list/mileage-dictionary-list.request";
import MileageDictionaryListParams from "./mileage-dictionary-list-params";

const create = (
  params: MileageDictionaryListParams,
): MileageDictionaryListRequest => {
  return {
    limit: params.limit,
    offset: params.offset,
    cargoCompanyUuid: params.cargoCompanyUuid,
    active: params.active,
  };
};

const MileageDictionaryListParamsFactory = {
  create,
};

export default MileageDictionaryListParamsFactory;
